import { render, staticRenderFns } from "./PropRecordKeepingCredit.vue?vue&type=template&id=67b9f9c7&scoped=true&"
import script from "./PropRecordKeepingCredit.vue?vue&type=script&lang=js&"
export * from "./PropRecordKeepingCredit.vue?vue&type=script&lang=js&"
import style0 from "./PropRecordKeepingCredit.vue?vue&type=style&index=0&id=67b9f9c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b9f9c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VDivider,VRow,VSpacer,VSwitch,VToolbar})
